/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getCampaigns = /* GraphQL */ `
  query GetCampaigns($account: String, $customer: String) {
    getCampaigns(account: $account, customer: $customer) {
      statusCode
      body
      __typename
    }
  }
`;
export const getConversations = /* GraphQL */ `
  query GetConversations(
    $customer: String
    $campaign: String
    $page: Int
    $conversation_ids: [String]
    $limit: Int
  ) {
    getConversations(
      customer: $customer
      campaign: $campaign
      page: $page
      conversation_ids: $conversation_ids
      limit: $limit
    ) {
      statusCode
      body
      __typename
    }
  }
`;
export const getThreadMessages = /* GraphQL */ `
  query GetThreadMessages($agent_id: String, $new_thread: Boolean) {
    getThreadMessages(agent_id: $agent_id, new_thread: $new_thread) {
      statusCode
      body
      __typename
    }
  }
`;
export const getCustomers = /* GraphQL */ `
  query GetCustomers($account: String) {
    getCustomers(account: $account) {
      statusCode
      body
      __typename
    }
  }
`;
export const putFiles = /* GraphQL */ `
  query PutFiles(
    $user_id: String
    $user_policy: [String]
    $authorizer: String
    $customer: String
    $s3_bucket: String
    $groups: [String]
    $files: [AWSJSON]
  ) {
    putFiles(
      user_id: $user_id
      user_policy: $user_policy
      authorizer: $authorizer
      customer: $customer
      s3_bucket: $s3_bucket
      groups: $groups
      files: $files
    ) {
      id
      statusCode
      status
      body
      __typename
    }
  }
`;
export const deleteFiles = /* GraphQL */ `
  query DeleteFiles($customer_id: String, $user_id: String, $file_id: String) {
    deleteFiles(
      customer_id: $customer_id
      user_id: $user_id
      file_id: $file_id
    ) {
      statusCode
      body
      __typename
    }
  }
`;
export const getFiles = /* GraphQL */ `
  query GetFiles($user_id: String) {
    getFiles(user_id: $user_id) {
      statusCode
      body
      __typename
    }
  }
`;
export const ghlRequest = /* GraphQL */ `
  query GhlRequest(
    $customer: String!
    $method: String!
    $path: String!
    $version: String!
    $body: AWSJSON
  ) {
    ghlRequest(
      customer: $customer
      method: $method
      path: $path
      version: $version
      body: $body
    ) {
      statusCode
      body
      __typename
    }
  }
`;
export const putAgent = /* GraphQL */ `
  query PutAgent(
    $name: String
    $id: String
    $knowledge_base: [String]
    $customer_id: String
    $provider: String
    $prompt: String
    $model: String
    $human_instructions: String
    $channels: [String]
    $domain: String
    $current_prompt_id: String
  ) {
    putAgent(
      name: $name
      id: $id
      knowledge_base: $knowledge_base
      customer_id: $customer_id
      provider: $provider
      prompt: $prompt
      model: $model
      human_instructions: $human_instructions
      channels: $channels
      domain: $domain
      current_prompt_id: $current_prompt_id
    ) {
      statusCode
      body
      __typename
    }
  }
`;
export const getAgent = /* GraphQL */ `
  query GetAgent(
    $customer_id: String
    $domain: String
    $provider: String
    $group: Boolean
  ) {
    getAgent(
      customer_id: $customer_id
      domain: $domain
      provider: $provider
      group: $group
    ) {
      statusCode
      body
      __typename
    }
  }
`;
export const deleteAgent = /* GraphQL */ `
  query DeleteAgent($customer_id: String, $id: String) {
    deleteAgent(customer_id: $customer_id, id: $id) {
      statusCode
      body
      __typename
    }
  }
`;
export const putCustomer = /* GraphQL */ `
  query PutCustomer(
    $name: String
    $address: String
    $id: String
    $phone: String
    $email: String
    $linkedin: String
    $domains: [String]
    $status: String
    $email_domains: [String]
    $voice_numbers: [String]
    $sms_numbers: [String]
    $company: String
    $city: String
    $state: String
    $lead_email: AWSJSON
    $messaging_schedule: AWSJSON
    $buy_box: AWSJSON
    $maoc_config: AWSJSON
  ) {
    putCustomer(
      name: $name
      address: $address
      id: $id
      phone: $phone
      email: $email
      linkedin: $linkedin
      domains: $domains
      status: $status
      email_domains: $email_domains
      voice_numbers: $voice_numbers
      sms_numbers: $sms_numbers
      company: $company
      city: $city
      state: $state
      lead_email: $lead_email
      messaging_schedule: $messaging_schedule
      buy_box: $buy_box
      maoc_config: $maoc_config
    ) {
      statusCode
      body
      __typename
    }
  }
`;
export const getCustomer = /* GraphQL */ `
  query GetCustomer($id: String, $status: String) {
    getCustomer(id: $id, status: $status) {
      statusCode
      body
      __typename
    }
  }
`;
export const getUser = /* GraphQL */ `
  query GetUser($email: String!, $customer_id: String) {
    getUser(email: $email, customer_id: $customer_id) {
      statusCode
      body
      __typename
    }
  }
`;
export const getAllUsers = /* GraphQL */ `
  query GetAllUsers(
    $customer_id: String
    $active: Boolean
    $next_page: AWSJSON
  ) {
    getAllUsers(
      customer_id: $customer_id
      active: $active
      next_page: $next_page
    ) {
      statusCode
      body
      __typename
    }
  }
`;
export const deleteCustomer = /* GraphQL */ `
  query DeleteCustomer($id: String) {
    deleteCustomer(id: $id) {
      statusCode
      body
      __typename
    }
  }
`;
export const putImportContact = /* GraphQL */ `
  query PutImportContact(
    $user_id: String
    $s3_file_name: String
    $customer_id: String
    $mapped_fields: AWSJSON
  ) {
    putImportContact(
      user_id: $user_id
      s3_file_name: $s3_file_name
      customer_id: $customer_id
      mapped_fields: $mapped_fields
    ) {
      statusCode
      body
      __typename
    }
  }
`;
export const putContact = /* GraphQL */ `
  query PutContact(
    $customer: String
    $firstname: String
    $lastname: String
    $email: String
    $properties: [AWSJSON]
    $phone: String
    $id: String
    $insert_date: String
    $last_modified: String
    $active: Boolean
    $metadata: AWSJSON
    $additional_attributes: AWSJSON
  ) {
    putContact(
      customer: $customer
      firstname: $firstname
      lastname: $lastname
      email: $email
      properties: $properties
      phone: $phone
      id: $id
      insert_date: $insert_date
      last_modified: $last_modified
      active: $active
      metadata: $metadata
      additional_attributes: $additional_attributes
    ) {
      statusCode
      body
      __typename
    }
  }
`;
export const getContact = /* GraphQL */ `
  query GetContact(
    $id: String
    $customer: String
    $limit: Int
    $next_token: AWSJSON
  ) {
    getContact(
      id: $id
      customer: $customer
      limit: $limit
      next_token: $next_token
    ) {
      statusCode
      body
      __typename
    }
  }
`;
export const searchContact = /* GraphQL */ `
  query SearchContact(
    $customer: String!
    $id: String
    $phone: String
    $email: String
    $first_name: String
    $last_name: String
    $limit: Int
    $next_token: AWSJSON
  ) {
    searchContact(
      customer: $customer
      id: $id
      phone: $phone
      email: $email
      first_name: $first_name
      last_name: $last_name
      limit: $limit
      next_token: $next_token
    ) {
      statusCode
      body
      __typename
    }
  }
`;
export const deleteContact = /* GraphQL */ `
  query DeleteContact($id: String, $customer: String) {
    deleteContact(id: $id, customer: $customer) {
      statusCode
      body
      __typename
    }
  }
`;
export const putFeedback = /* GraphQL */ `
  query PutFeedback(
    $user_id: String
    $vote: String
    $campaign: String
    $agent_id: String
    $comment: String
    $message: String
    $message_id: String
  ) {
    putFeedback(
      user_id: $user_id
      vote: $vote
      campaign: $campaign
      agent_id: $agent_id
      comment: $comment
      message: $message
      message_id: $message_id
    ) {
      statusCode
      body
      __typename
    }
  }
`;
export const getFeedback = /* GraphQL */ `
  query GetFeedback(
    $user_id: String
    $id: String
    $agent_id: String
    $campaign_id: String
    $message_id: String
    $vote: String
  ) {
    getFeedback(
      user_id: $user_id
      id: $id
      agent_id: $agent_id
      campaign_id: $campaign_id
      message_id: $message_id
      vote: $vote
    ) {
      statusCode
      body
      __typename
    }
  }
`;
export const deleteFeedback = /* GraphQL */ `
  query DeleteFeedback($user_id: String, $id: String) {
    deleteFeedback(user_id: $user_id, id: $id) {
      statusCode
      body
      __typename
    }
  }
`;
export const putPrompt = /* GraphQL */ `
  query PutPrompt(
    $user_id: String
    $name: String
    $description: String
    $human_instruction: String
    $features: [String]
    $guardrails: [String]
    $prompt_type: String
    $id: String
    $full_text: String
    $input_variables: [String]
  ) {
    putPrompt(
      user_id: $user_id
      name: $name
      description: $description
      human_instruction: $human_instruction
      features: $features
      guardrails: $guardrails
      prompt_type: $prompt_type
      id: $id
      full_text: $full_text
      input_variables: $input_variables
    ) {
      statusCode
      body
      __typename
    }
  }
`;
export const getPrompt = /* GraphQL */ `
  query GetPrompt($user_id: String, $id: String, $commit_hash: String) {
    getPrompt(user_id: $user_id, id: $id, commit_hash: $commit_hash) {
      statusCode
      body
      __typename
    }
  }
`;
export const getPrompts = /* GraphQL */ `
  query GetPrompts(
    $user_id: String
    $id: String
    $prompt_type: String
    $page_size: Int
    $page_number: Int
  ) {
    getPrompts(
      user_id: $user_id
      id: $id
      prompt_type: $prompt_type
      page_size: $page_size
      page_number: $page_number
    ) {
      statusCode
      body
      __typename
    }
  }
`;
export const deletePrompt = /* GraphQL */ `
  query DeletePrompt($user_id: String, $id: String) {
    deletePrompt(user_id: $user_id, id: $id) {
      statusCode
      body
      __typename
    }
  }
`;
export const aiEdit = /* GraphQL */ `
  query AiEdit($message: String!, $edit_type: String!, $tone: String) {
    aiEdit(message: $message, edit_type: $edit_type, tone: $tone) {
      id
      statusCode
      status
      body
      __typename
    }
  }
`;
export const getPlaygroundConversation = /* GraphQL */ `
  query GetPlaygroundConversation(
    $customer_id: String
    $agent_id: String
    $message: String
    $thread: String
    $user_id: String
  ) {
    getPlaygroundConversation(
      customer_id: $customer_id
      agent_id: $agent_id
      message: $message
      thread: $thread
      user_id: $user_id
    ) {
      id
      statusCode
      status
      body
      __typename
    }
  }
`;
export const getPlaygroundLangchainConversation = /* GraphQL */ `
  query GetPlaygroundLangchainConversation(
    $model: String
    $agent_id: String
    $user_id: String
    $message: String
    $thread: String
    $agent_prompt: String
    $knowledge_base: [String]
    $customer_id: String
  ) {
    getPlaygroundLangchainConversation(
      model: $model
      agent_id: $agent_id
      user_id: $user_id
      message: $message
      thread: $thread
      agent_prompt: $agent_prompt
      knowledge_base: $knowledge_base
      customer_id: $customer_id
    ) {
      id
      statusCode
      status
      body
      __typename
    }
  }
`;
export const getAgentTest = /* GraphQL */ `
  query GetAgentTest(
    $persona_info: String
    $situation_goals_info: String
    $turns: Int
    $agent_info: AWSJSON
  ) {
    getAgentTest(
      persona_info: $persona_info
      situation_goals_info: $situation_goals_info
      turns: $turns
      agent_info: $agent_info
    ) {
      statusCode
      body
      __typename
    }
  }
`;
export const getPublicProperty = /* GraphQL */ `
  query GetPublicProperty($customer: String!, $property_id: String!) {
    getPublicProperty(customer: $customer, property_id: $property_id) {
      statusCode
      body
      __typename
    }
  }
`;
export const fetchProperties = /* GraphQL */ `
  query FetchProperties(
    $customer: String!
    $property_ids: [String]
    $next_page: AWSJSON
    $limit: Int
    $filters: AWSJSON
    $user_id: String
    $user_role: String
  ) {
    fetchProperties(
      customer: $customer
      property_ids: $property_ids
      next_page: $next_page
      limit: $limit
      filters: $filters
      user_id: $user_id
      user_role: $user_role
    ) {
      statusCode
      body
      __typename
    }
  }
`;
export const batchGetProperties = /* GraphQL */ `
  query BatchGetProperties($customer_id: String!, $property_ids: [String!]!) {
    batchGetProperties(customer_id: $customer_id, property_ids: $property_ids) {
      statusCode
      body
      __typename
    }
  }
`;
export const putCampaignEmail = /* GraphQL */ `
  query PutCampaignEmail(
    $destination: [AWSJSON]
    $source: String
    $source_name: String
    $subject: String
    $text_body: String
    $id: String
    $type: String
    $name: String
    $status: String
    $totalRecipients: Int
    $html_body: String
    $metadata: AWSJSON
    $channels: AWSJSON
    $contact_file: AWSJSON
    $contact_headers_map: AWSJSON
    $retries: [AWSJSON]
    $customer: String
  ) {
    putCampaignEmail(
      destination: $destination
      source: $source
      source_name: $source_name
      subject: $subject
      text_body: $text_body
      id: $id
      type: $type
      name: $name
      status: $status
      totalRecipients: $totalRecipients
      html_body: $html_body
      metadata: $metadata
      channels: $channels
      contact_file: $contact_file
      contact_headers_map: $contact_headers_map
      retries: $retries
      customer: $customer
    ) {
      statusCode
      body
      __typename
    }
  }
`;
export const putCampaignSms = /* GraphQL */ `
  query PutCampaignSms(
    $id: String
    $name: String
    $phoneNumber: String
    $source: String
    $type: String
    $status: String
    $totalRecipients: Int
    $metadata: AWSJSON
    $channels: AWSJSON
    $contact_file: AWSJSON
  ) {
    putCampaignSms(
      id: $id
      name: $name
      phoneNumber: $phoneNumber
      source: $source
      type: $type
      status: $status
      totalRecipients: $totalRecipients
      metadata: $metadata
      channels: $channels
      contact_file: $contact_file
    ) {
      statusCode
      body
      __typename
    }
  }
`;
export const getCampaign = /* GraphQL */ `
  query GetCampaign(
    $customer: String
    $user_id: String
    $status: String
    $contacts: [AWSJSON]
  ) {
    getCampaign(
      customer: $customer
      user_id: $user_id
      status: $status
      contacts: $contacts
    ) {
      statusCode
      body
      __typename
    }
  }
`;
export const putCampaign = /* GraphQL */ `
  query PutCampaign(
    $id: String
    $name: String
    $status: String
    $customer: String
    $metadata: AWSJSON
    $channels: AWSJSON
    $context: String
    $retries: [AWSJSON]
    $source_name: String
    $source: String
    $protected_intents: [String]
  ) {
    putCampaign(
      id: $id
      name: $name
      status: $status
      customer: $customer
      metadata: $metadata
      channels: $channels
      context: $context
      retries: $retries
      source_name: $source_name
      source: $source
      protected_intents: $protected_intents
    ) {
      statusCode
      body
      __typename
    }
  }
`;
export const getCampaignEmailRetryTemplate = /* GraphQL */ `
  query GetCampaignEmailRetryTemplate(
    $unit: String
    $value: Int
    $message: String
  ) {
    getCampaignEmailRetryTemplate(
      unit: $unit
      value: $value
      message: $message
    ) {
      statusCode
      body
      __typename
    }
  }
`;
export const getSchema = /* GraphQL */ `
  query GetSchema($account: String, $entity: String) {
    getSchema(account: $account, entity: $entity) {
      statusCode
      body
      __typename
    }
  }
`;
export const putSchema = /* GraphQL */ `
  query PutSchema(
    $account: String
    $id: String
    $name: String
    $description: String
    $related_entity: String
    $version: String
    $structure: [SchemaStructure]
  ) {
    putSchema(
      account: $account
      id: $id
      name: $name
      description: $description
      related_entity: $related_entity
      version: $version
      structure: $structure
    ) {
      statusCode
      body
      __typename
    }
  }
`;
export const putApproveMessage = /* GraphQL */ `
  query PutApproveMessage($message_id: String, $campaign_id: String) {
    putApproveMessage(message_id: $message_id, campaign_id: $campaign_id) {
      statusCode
      body
      __typename
    }
  }
`;
export const putMessage = /* GraphQL */ `
  query PutMessage(
    $message_id: String
    $campaign_id: String
    $body: String
    $check_gramma: Boolean
    $new_reply: Boolean
  ) {
    putMessage(
      message_id: $message_id
      campaign_id: $campaign_id
      body: $body
      check_gramma: $check_gramma
      new_reply: $new_reply
    ) {
      statusCode
      body
      __typename
    }
  }
`;
export const sendSms = /* GraphQL */ `
  query SendSms(
    $message_body: String
    $recipient_number: String
    $customer: String
    $campaign_id: String
  ) {
    sendSms(
      message_body: $message_body
      recipient_number: $recipient_number
      customer: $customer
      campaign_id: $campaign_id
    ) {
      statusCode
      body
      __typename
    }
  }
`;
export const getMessages = /* GraphQL */ `
  query GetMessages(
    $customer: String
    $status: String
    $campaign_id: String
    $start_date: String
    $end_date: String
    $limit: String
  ) {
    getMessages(
      customer: $customer
      status: $status
      campaign_id: $campaign_id
      start_date: $start_date
      end_date: $end_date
      limit: $limit
    ) {
      statusCode
      body
      __typename
    }
  }
`;
export const deleteMessages = /* GraphQL */ `
  query DeleteMessages($messages: [AWSJSON]) {
    deleteMessages(messages: $messages) {
      statusCode
      body
      __typename
    }
  }
`;
export const getIntent = /* GraphQL */ `
  query GetIntent($id: String, $campaign_id: String) {
    getIntent(id: $id, campaign_id: $campaign_id) {
      statusCode
      body
      __typename
    }
  }
`;
export const putIntent = /* GraphQL */ `
  query PutIntent(
    $intents: [AWSJSON]
    $campaign_id: String
    $message: AWSJSON
  ) {
    putIntent(intents: $intents, campaign_id: $campaign_id, message: $message) {
      statusCode
      body
      __typename
    }
  }
`;
export const sharePublicMaoc = /* GraphQL */ `
  query SharePublicMaoc(
    $maoc_id: String!
    $customer: String!
    $property_customer: String
    $calculation: AWSJSON!
    $editor: String!
    $status: String
    $message: String
    $hidden_address: Boolean
  ) {
    sharePublicMaoc(
      maoc_id: $maoc_id
      customer: $customer
      property_customer: $property_customer
      calculation: $calculation
      editor: $editor
      status: $status
      message: $message
      hidden_address: $hidden_address
    ) {
      statusCode
      body
      __typename
    }
  }
`;
export const inviteUser = /* GraphQL */ `
  query InviteUser(
    $firstname: String!
    $lastname: String!
    $phone: String!
    $email: String!
    $account: String!
    $groups: [String]!
    $company: String
  ) {
    inviteUser(
      firstname: $firstname
      lastname: $lastname
      phone: $phone
      email: $email
      account: $account
      groups: $groups
      company: $company
    ) {
      statusCode
      body
      __typename
    }
  }
`;
export const getBugReporterChat = /* GraphQL */ `
  query GetBugReporterChat(
    $user_id: String!
    $user_message: String!
    $image_name: String
  ) {
    getBugReporterChat(
      user_id: $user_id
      user_message: $user_message
      image_name: $image_name
    ) {
      statusCode
      body
      __typename
    }
  }
`;
export const getSignedS3PostUrl = /* GraphQL */ `
  query GetSignedS3PostUrl($bucket_name: String!, $object_name: String!) {
    getSignedS3PostUrl(bucket_name: $bucket_name, object_name: $object_name) {
      statusCode
      body
      __typename
    }
  }
`;
export const getSignedS3DownloadUrl = /* GraphQL */ `
  query GetSignedS3DownloadUrl($bucket_name: String!, $object_name: String!) {
    getSignedS3DownloadUrl(
      bucket_name: $bucket_name
      object_name: $object_name
    ) {
      statusCode
      body
      __typename
    }
  }
`;
export const findTouchingParcels = /* GraphQL */ `
  query FindTouchingParcels(
    $query_id: String!
    $lat: Float!
    $lon: Float!
    $state: String!
    $county: String!
    $source_address: String
    $response_mutation: Boolean
  ) {
    findTouchingParcels(
      query_id: $query_id
      lat: $lat
      lon: $lon
      state: $state
      county: $county
      source_address: $source_address
      response_mutation: $response_mutation
    ) {
      statusCode
      body
      __typename
    }
  }
`;
export const findParcelsInRadius = /* GraphQL */ `
  query FindParcelsInRadius(
    $query_id: String!
    $lat: Float!
    $lon: Float!
    $buffer_shape: String!
    $length_meters: Float
    $width_meters: Float
    $radius_meters: Float
    $state: String!
    $county: String!
    $response_mutation: Boolean
  ) {
    findParcelsInRadius(
      query_id: $query_id
      lat: $lat
      lon: $lon
      buffer_shape: $buffer_shape
      length_meters: $length_meters
      width_meters: $width_meters
      radius_meters: $radius_meters
      state: $state
      county: $county
      response_mutation: $response_mutation
    ) {
      statusCode
      body
      __typename
    }
  }
`;
export const getContactSummary = /* GraphQL */ `
  query GetContactSummary(
    $customer: String!
    $contact_file: String!
    $map_attributes: AWSJSON
  ) {
    getContactSummary(
      customer: $customer
      contact_file: $contact_file
      map_attributes: $map_attributes
    ) {
      statusCode
      body
      __typename
    }
  }
`;
export const getManyCampaignConvos = /* GraphQL */ `
  query GetManyCampaignConvos(
    $customer: String
    $campaign_ids: [String]
    $nextToken: AWSJSON
    $conversation_ids: [String]
    $limit: String
  ) {
    getManyCampaignConvos(
      customer: $customer
      campaign_ids: $campaign_ids
      nextToken: $nextToken
      conversation_ids: $conversation_ids
      limit: $limit
    ) {
      statusCode
      body
      __typename
    }
  }
`;
export const getZillowProperty = /* GraphQL */ `
  query GetZillowProperty(
    $zillow_urls: [String]
    $addresses: [String]
    $customer: String!
    $user_id: String!
    $referrer_name: String
    $referrer_phone: String
    $referrer_email: String
    $min_asking_price: Float
    $hidden_address: Boolean
    $type: String!
  ) {
    getZillowProperty(
      zillow_urls: $zillow_urls
      addresses: $addresses
      customer: $customer
      user_id: $user_id
      referrer_name: $referrer_name
      referrer_phone: $referrer_phone
      referrer_email: $referrer_email
      min_asking_price: $min_asking_price
      hidden_address: $hidden_address
      type: $type
    ) {
      id
      statusCode
      status
      body
      __typename
    }
  }
`;
export const fetchUnifiedInbox = /* GraphQL */ `
  query FetchUnifiedInbox(
    $customer: String!
    $campaign: String
    $campaign_name: String
    $thread: String
    $contact_first_name: String
    $contact_last_name: String
    $read: Boolean
    $favorite: Boolean
    $subject: String
    $channel: String
    $sender: String
    $receiver: String
    $with_reply: Boolean
    $most_recent: Boolean
    $intent: String
    $next_token: AWSJSON
    $limit: Int
    $scan_index_forward: Boolean
  ) {
    fetchUnifiedInbox(
      customer: $customer
      campaign: $campaign
      campaign_name: $campaign_name
      thread: $thread
      contact_first_name: $contact_first_name
      contact_last_name: $contact_last_name
      read: $read
      favorite: $favorite
      subject: $subject
      channel: $channel
      sender: $sender
      receiver: $receiver
      with_reply: $with_reply
      most_recent: $most_recent
      intent: $intent
      next_token: $next_token
      limit: $limit
      scan_index_forward: $scan_index_forward
    ) {
      statusCode
      body
      __typename
    }
  }
`;
export const markUnifiedMessage = /* GraphQL */ `
  query MarkUnifiedMessage(
    $customer: String
    $campaign: String
    $thread: String
    $timestamp: String
    $read: Boolean
    $favorite: Boolean
  ) {
    markUnifiedMessage(
      customer: $customer
      campaign: $campaign
      thread: $thread
      timestamp: $timestamp
      read: $read
      favorite: $favorite
    ) {
      statusCode
      body
      __typename
    }
  }
`;
export const setMessageRead = /* GraphQL */ `
  query SetMessageRead(
    $message_id: String
    $campaign_id: String
    $read_status: Boolean
  ) {
    setMessageRead(
      message_id: $message_id
      campaign_id: $campaign_id
      read_status: $read_status
    ) {
      statusCode
      body
      __typename
    }
  }
`;
export const getMaoc = /* GraphQL */ `
  query GetMaoc(
    $maoc_id: String!
    $customer_id: String!
    $user_data: AWSJSON
    $include_all_strategies: Boolean
  ) {
    getMaoc(
      maoc_id: $maoc_id
      customer_id: $customer_id
      user_data: $user_data
      include_all_strategies: $include_all_strategies
    ) {
      statusCode
      body
      __typename
    }
  }
`;
export const getMaocLatest = /* GraphQL */ `
  query GetMaocLatest(
    $buyer: String!
    $seller: String
    $property_id: String!
    $customer_id: String
    $user_data: AWSJSON
    $customer_latest: Boolean
  ) {
    getMaocLatest(
      buyer: $buyer
      seller: $seller
      property_id: $property_id
      customer_id: $customer_id
      user_data: $user_data
      customer_latest: $customer_latest
    ) {
      statusCode
      body
      __typename
    }
  }
`;
export const putMaoc = /* GraphQL */ `
  query PutMaoc(
    $customer: String!
    $buyer: String!
    $seller: String!
    $status: String!
    $property: String!
    $county: String!
    $property_customer: String
    $calculation: AWSJSON!
    $editor: String!
    $id: String
    $insert_date: String
    $last_modified: String
    $return_url: Boolean
    $metadata: AWSJSON
    $strategy_name: String
  ) {
    putMaoc(
      customer: $customer
      buyer: $buyer
      seller: $seller
      status: $status
      property: $property
      county: $county
      property_customer: $property_customer
      calculation: $calculation
      editor: $editor
      id: $id
      insert_date: $insert_date
      last_modified: $last_modified
      return_url: $return_url
      metadata: $metadata
      strategy_name: $strategy_name
    ) {
      statusCode
      body
      __typename
    }
  }
`;
export const getAllDealLens = /* GraphQL */ `
  query GetAllDealLens(
    $user_email: String!
    $query_role: String!
    $customer: String!
    $status: String
    $county: String
    $bed: Int
    $bath: Int
    $sqft_min: Int
    $sqft_max: Int
    $year_built_min: Int
    $year_built_max: Int
    $swipe_status: String
    $latest_per_thread: Boolean
    $next_page: AWSJSON
  ) {
    getAllDealLens(
      user_email: $user_email
      query_role: $query_role
      customer: $customer
      status: $status
      county: $county
      bed: $bed
      bath: $bath
      sqft_min: $sqft_min
      sqft_max: $sqft_max
      year_built_min: $year_built_min
      year_built_max: $year_built_max
      swipe_status: $swipe_status
      latest_per_thread: $latest_per_thread
      next_page: $next_page
    ) {
      statusCode
      body
      __typename
    }
  }
`;
export const getDealLens = /* GraphQL */ `
  query GetDealLens(
    $deallens_id: String!
    $sender: String!
    $user_id: String!
    $customer: String
  ) {
    getDealLens(
      deallens_id: $deallens_id
      sender: $sender
      user_id: $user_id
      customer: $customer
    ) {
      statusCode
      body
      __typename
    }
  }
`;
export const getDeallensThread = /* GraphQL */ `
  query GetDeallensThread(
    $thread: String!
    $collection_id: String!
    $customer: String!
    $next_page: AWSJSON
  ) {
    getDeallensThread(
      thread: $thread
      collection_id: $collection_id
      customer: $customer
      next_page: $next_page
    ) {
      statusCode
      body
      __typename
    }
  }
`;
export const getDeallensMessages = /* GraphQL */ `
  query GetDeallensMessages(
    $collection_id: String!
    $customer: String!
    $campaign: String
    $next_page: AWSJSON
  ) {
    getDeallensMessages(
      collection_id: $collection_id
      customer: $customer
      campaign: $campaign
      next_page: $next_page
    ) {
      statusCode
      body
      __typename
    }
  }
`;
export const getCollectionFeed = /* GraphQL */ `
  query GetCollectionFeed(
    $customer: String!
    $property_id: String!
    $collection_id: String!
    $role: String
    $next_page: AWSJSON
    $limit: Int
    $order: String
  ) {
    getCollectionFeed(
      customer: $customer
      property_id: $property_id
      collection_id: $collection_id
      role: $role
      next_page: $next_page
      limit: $limit
      order: $order
    ) {
      statusCode
      body
      __typename
    }
  }
`;
export const getCollectionOffers = /* GraphQL */ `
  query GetCollectionOffers(
    $customer: String!
    $property_id: String!
    $collection_id: String!
    $role: String
    $next_page: AWSJSON
    $limit: Int
    $order: String
  ) {
    getCollectionOffers(
      customer: $customer
      property_id: $property_id
      collection_id: $collection_id
      role: $role
      next_page: $next_page
      limit: $limit
      order: $order
    ) {
      statusCode
      body
      __typename
    }
  }
`;
export const getCollectionTips = /* GraphQL */ `
  query GetCollectionTips(
    $customer: String!
    $property_id: String!
    $role: String
    $investor: String
    $next_page: AWSJSON
    $max_items: Int
  ) {
    getCollectionTips(
      customer: $customer
      property_id: $property_id
      role: $role
      investor: $investor
      next_page: $next_page
      max_items: $max_items
    ) {
      statusCode
      body
      __typename
    }
  }
`;
export const getDeallensPropertyThreads = /* GraphQL */ `
  query GetDeallensPropertyThreads(
    $customer: String!
    $property_id: String!
    $role: String
    $by_collection: Boolean
  ) {
    getDeallensPropertyThreads(
      customer: $customer
      property_id: $property_id
      role: $role
      by_collection: $by_collection
    ) {
      statusCode
      body
      __typename
    }
  }
`;
export const getPropertiesThread = /* GraphQL */ `
  query GetPropertiesThread($maoc_id: String!, $customer_id: String!) {
    getPropertiesThread(maoc_id: $maoc_id, customer_id: $customer_id) {
      statusCode
      body
      __typename
    }
  }
`;
export const updateProperty = /* GraphQL */ `
  query UpdateProperty(
    $customer: String!
    $county: String!
    $full_address: String
    $city: String!
    $state: String!
    $zipcode: String!
    $street_name: String!
    $street_number: String!
    $unit_number: String
    $contacts: [AWSJSON]
    $id: String
    $active: Boolean
    $metadata: AWSJSON
    $additional_attributes: AWSJSON
    $delete_comp_ids: [String]
    $hidden_address: Boolean
  ) {
    updateProperty(
      customer: $customer
      county: $county
      full_address: $full_address
      city: $city
      state: $state
      zipcode: $zipcode
      street_name: $street_name
      street_number: $street_number
      unit_number: $unit_number
      contacts: $contacts
      id: $id
      active: $active
      metadata: $metadata
      additional_attributes: $additional_attributes
      delete_comp_ids: $delete_comp_ids
      hidden_address: $hidden_address
    ) {
      statusCode
      body
      __typename
    }
  }
`;
export const invokeSowAgent = /* GraphQL */ `
  query InvokeSowAgent(
    $message: String!
    $model_selection: String!
    $user_id: String!
    $customer: String!
    $property_id: String
    $strategy_name: String
  ) {
    invokeSowAgent(
      message: $message
      model_selection: $model_selection
      user_id: $user_id
      customer: $customer
      property_id: $property_id
      strategy_name: $strategy_name
    ) {
      id
      statusCode
      status
      body
      __typename
    }
  }
`;
export const invokeAgent = /* GraphQL */ `
  query InvokeAgent(
    $agent: String!
    $property_id: String!
    $user_id: String!
    $customer: String!
    $model_name: String
    $comps: [AWSJSON]
    $comps_analysis: String
    $strategies: [String]
    $mode: String
  ) {
    invokeAgent(
      agent: $agent
      property_id: $property_id
      user_id: $user_id
      customer: $customer
      model_name: $model_name
      comps: $comps
      comps_analysis: $comps_analysis
      strategies: $strategies
      mode: $mode
    ) {
      id
      statusCode
      status
      body
      __typename
    }
  }
`;
export const invokeQmaAutomation = /* GraphQL */ `
  query InvokeQmaAutomation(
    $property_id: String!
    $user_id: String!
    $customer: String!
    $model_name: String!
    $comps: [AWSJSON]
    $comps_analysis: String
  ) {
    invokeQmaAutomation(
      property_id: $property_id
      user_id: $user_id
      customer: $customer
      model_name: $model_name
      comps: $comps
      comps_analysis: $comps_analysis
    ) {
      id
      statusCode
      status
      body
      __typename
    }
  }
`;
export const invokeCompsAgent = /* GraphQL */ `
  query InvokeCompsAgent(
    $property_id: String!
    $user_id: String!
    $customer: String!
    $model_name: String!
  ) {
    invokeCompsAgent(
      property_id: $property_id
      user_id: $user_id
      customer: $customer
      model_name: $model_name
    ) {
      id
      statusCode
      status
      body
      __typename
    }
  }
`;
export const invokeExitStrategy = /* GraphQL */ `
  query InvokeExitStrategy(
    $customer: String!
    $property_id: String!
    $user_id: String!
    $strategies: [String]
    $model_name: String
  ) {
    invokeExitStrategy(
      customer: $customer
      property_id: $property_id
      user_id: $user_id
      strategies: $strategies
      model_name: $model_name
    ) {
      id
      statusCode
      status
      body
      __typename
    }
  }
`;
export const invokeExitStrategyChat = /* GraphQL */ `
  query InvokeExitStrategyChat(
    $message: String!
    $customer: String!
    $property_id: String!
    $user_id: String!
    $strategy_key: String!
    $model_name: String
  ) {
    invokeExitStrategyChat(
      message: $message
      customer: $customer
      property_id: $property_id
      user_id: $user_id
      strategy_key: $strategy_key
      model_name: $model_name
    ) {
      id
      statusCode
      status
      body
      __typename
    }
  }
`;
export const getPropComps = /* GraphQL */ `
  query GetPropComps(
    $customer: String!
    $property_id: String!
    $comps: [String!]!
  ) {
    getPropComps(
      customer: $customer
      property_id: $property_id
      comps: $comps
    ) {
      statusCode
      body
      __typename
    }
  }
`;
export const clearCheckpoint = /* GraphQL */ `
  query ClearCheckpoint(
    $customer: String!
    $user_id: String!
    $agent_type: String
    $property_id: String
  ) {
    clearCheckpoint(
      customer: $customer
      user_id: $user_id
      agent_type: $agent_type
      property_id: $property_id
    ) {
      id
      statusCode
      status
      body
      __typename
    }
  }
`;
export const putDeallens = /* GraphQL */ `
  query PutDeallens(
    $sender: String!
    $sender_role: String!
    $receiver_role: String!
    $property_id: String!
    $calculation: AWSJSON!
    $customer: String!
    $homeowner_email: String
    $representative: String
    $receiver: String
    $receivers: [String]
    $bed: Float
    $bath: Float
    $sqft: Float
    $county: String!
    $full_address: String
    $city: String
    $state: String
    $zipcode: String
    $year_built: Float
    $hidden_address: Boolean
    $status: String
    $message_status: String
    $distribute: Boolean
    $swipe_status: String
    $metadata: AWSJSON
    $offer_id: String
    $thread: String
    $collection_id: String
  ) {
    putDeallens(
      sender: $sender
      sender_role: $sender_role
      receiver_role: $receiver_role
      property_id: $property_id
      calculation: $calculation
      customer: $customer
      homeowner_email: $homeowner_email
      representative: $representative
      receiver: $receiver
      receivers: $receivers
      bed: $bed
      bath: $bath
      sqft: $sqft
      county: $county
      full_address: $full_address
      city: $city
      state: $state
      zipcode: $zipcode
      year_built: $year_built
      hidden_address: $hidden_address
      status: $status
      message_status: $message_status
      distribute: $distribute
      swipe_status: $swipe_status
      metadata: $metadata
      offer_id: $offer_id
      thread: $thread
      collection_id: $collection_id
    ) {
      statusCode
      body
      __typename
    }
  }
`;
